<form [formGroup]="formGroup" class="q-form">
  @for (element of elements; track element.name) {
    @if (element.type === "radiogroup") {
      <div class="q-card">
        <div class="q-title">
          <span>{{ element.title }}</span>
        </div>

        <div class="q-options">
          @for (choice of element.choices; track choice.value) {
            <label class="q-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span>{{ choice.text | translate }}</span>
            </label>
          }
        </div>
      </div>
    }
  }
</form>
